import classnames from 'classnames/bind'
import useAnimateInView from 'hooks/useAnimateInView'
import useRefs from 'hooks/useRefs'
import useTimeline from 'hooks/useTimeline'
import { chunk } from 'lib/chunk'
import React, { useCallback, useRef } from 'react'
import ArticleCard from 'src/components/shared/ArticleCard'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ArticlesGrid = ({ className, duo, cards = [] }) => {
  const cardsRefs = useRefs(cards.length)
  const elementRef = useRef()

  const animateIn = useTimeline(
    { paused: true, restoreTime: true },
    (tl) => {
      const cards = chunk(
        cardsRefs.current.map((card) => card.current),
        6
      )
      const stagger = 0.1
      tl.set(elementRef.current, {
        opacity: 1,
      })

      if (cards && cards.length > 0) {
        for (let index = 0; index < cards.length; index++) {
          const cardsChunk = cards[index]
          tl.fromTo(
            cardsChunk,
            {
              opacity: 0,
            },
            {
              opacity: 1,
              duration: 0.2,
              stagger,
              ease: 'none',
            },
            '+=0.3'
          )

          tl.fromTo(
            cardsChunk,
            {
              z: -150,
            },
            {
              z: 0,
              transformPerspective: 1000,
              duration: 1.2,
              stagger,
              ease: 'elastic.out(0.4,0.2)',
            },
            '<'
          )
        }
      }
    },
    [cards]
  )

  const [inViewRef] = useAnimateInView({
    triggerOnce: true,
    animateIn: () => {
      animateIn.restart(true)
    },
  })

  const setRef = useCallback((node) => {
    elementRef.current = node
    inViewRef(node)
  }, [])

  return (
    <div ref={setRef} className={cx(className, css.ArticlesGrid, { duo })}>
      {cards &&
        cards.map((card, i) => {
          return (
            <ArticleCard
              duo={duo}
              key={`article-card-${i}`}
              ref={cardsRefs.current[i]}
              className={css.cardContainer}
              {...card}
            />
          )
        })}
    </div>
  )
}

export default ArticlesGrid
